import { useMutation, useQueryClient } from 'react-query';
import { createActivity } from 'App/services/RMSService';

const useCreateReferralActivityMutation = () => {
    const queryClient = useQueryClient();

    return useMutation(
        ({ patientId, referralId, body }) => {
            return createActivity(patientId, referralId, body);
        },
        {
            onSettled: (_activity, _error, variables) => {
                const queryPatientId = variables?.patientId;
                const queryReferralId = variables?.referralId;

                if (!queryPatientId || !queryReferralId) {
                    return undefined;
                }

                return queryClient.refetchQueries(['patient', queryPatientId, 'referral', queryReferralId, 'activity']);
            },
        }
    );
};

export default useCreateReferralActivityMutation;
